module.exports = {
	"schema": {
		"address1": {
			"type": "CapitalInput",
			"formatter": "title",
			"title": "Street address",
			"autoComplete": "off",
			"autoCorrect": "off",
			"autoCapitalize": "on",
			"validators": [
				"required",
				{
					"type": "regexp",
					"regexp": "/\\b[p]*(ost)*\\.*\\s*[o|0]*(ffice)*\\s?B(ox)?.*\\d+/i",
					"match": true,
					"message": "PO Boxes are not allowed."
				}
			]
		},
		"city": {
			"type": "CapitalInput",
			"formatter": "title",
			"title": "City",
			"autoComplete": "off",
			"autoCorrect": "off",
			"autoCapitalize": "on",
			"validators": [
				"required"
			]
		},
		"state": {
			"type": "Select",
			"title": "State",
			"options": [
				{
					"val": "",
					"label": "State"
				},
				{
					"val": "AA",
					"label": "AA"
				},
				{
					"val": "AE",
					"label": "AE"
				},
				{
					"val": "AK",
					"label": "AK"
				},
				{
					"val": "AL",
					"label": "AL"
				},
				{
					"val": "AP",
					"label": "AP"
				},
				{
					"val": "AR",
					"label": "AR"
				},
				{
					"val": "AS",
					"label": "AS"
				},
				{
					"val": "AZ",
					"label": "AZ"
				},
				{
					"val": "CA",
					"label": "CA"
				},
				{
					"val": "CO",
					"label": "CO"
				},
				{
					"val": "CT",
					"label": "CT"
				},
				{
					"val": "DC",
					"label": "DC"
				},
				{
					"val": "DE",
					"label": "DE"
				},
				{
					"val": "FL",
					"label": "FL"
				},
				{
					"val": "FM",
					"label": "FM"
				},
				{
					"val": "GA",
					"label": "GA"
				},
				{
					"val": "GU",
					"label": "GU"
				},
				{
					"val": "HI",
					"label": "HI"
				},
				{
					"val": "IA",
					"label": "IA"
				},
				{
					"val": "ID",
					"label": "ID"
				},
				{
					"val": "IL",
					"label": "IL"
				},
				{
					"val": "IN",
					"label": "IN"
				},
				{
					"val": "KS",
					"label": "KS"
				},
				{
					"val": "KY",
					"label": "KY"
				},
				{
					"val": "LA",
					"label": "LA"
				},
				{
					"val": "MA",
					"label": "MA"
				},
				{
					"val": "MD",
					"label": "MD"
				},
				{
					"val": "ME",
					"label": "ME"
				},
				{
					"val": "MH",
					"label": "MH"
				},
				{
					"val": "MI",
					"label": "MI"
				},
				{
					"val": "MN",
					"label": "MN"
				},
				{
					"val": "MP",
					"label": "MP"
				},
				{
					"val": "MO",
					"label": "MO"
				},
				{
					"val": "MS",
					"label": "MS"
				},
				{
					"val": "MT",
					"label": "MT"
				},
				{
					"val": "NC",
					"label": "NC"
				},
				{
					"val": "ND",
					"label": "ND"
				},
				{
					"val": "NE",
					"label": "NE"
				},
				{
					"val": "NH",
					"label": "NH"
				},
				{
					"val": "NJ",
					"label": "NJ"
				},
				{
					"val": "NM",
					"label": "NM"
				},
				{
					"val": "NV",
					"label": "NV"
				},
				{
					"val": "NY",
					"label": "NY"
				},
				{
					"val": "OH",
					"label": "OH"
				},
				{
					"val": "OK",
					"label": "OK"
				},
				{
					"val": "OR",
					"label": "OR"
				},
				{
					"val": "PA",
					"label": "PA"
				},
				{
					"val": "PR",
					"label": "PR"
				},
				{
					"val": "PW",
					"label": "PW"
				},
				{
					"val": "RI",
					"label": "RI"
				},
				{
					"val": "SC",
					"label": "SC"
				},
				{
					"val": "SD",
					"label": "SD"
				},
				{
					"val": "TN",
					"label": "TN"
				},
				{
					"val": "TX",
					"label": "TX"
				},
				{
					"val": "UT",
					"label": "UT"
				},
				{
					"val": "VA",
					"label": "VA"
				},
				{
					"val": "VI",
					"label": "VI"
				},
				{
					"val": "VT",
					"label": "VT"
				},
				{
					"val": "WA",
					"label": "WA"
				},
				{
					"val": "WI",
					"label": "WI"
				},
				{
					"val": "WV",
					"label": "WV"
				},
				{
					"val": "WY",
					"label": "WY"
				}
			],
			"validators": [
				"required"
			]
		},
		"zip": {
			"type": "MultiFormatInput",
			"formats": [
				"11111-1111",
				"11111"
			],
			"title": "Zip Code",
			"autoComplete": "off",
			"autoCorrect": "off",
			"validators": [
				"required",
				{
					"type": "multilength",
					"lengths": [
						5,
						9
					],
					"dataType": "number",
					"message": "Please check your ZIP code. It doesn't look right."
				}
			]
		}
	},
	"fieldsets": [
		"address1",
		{
			"template": "combined70",
			"fields": "city,state"
		},
		"zip"
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/schemas/Address.json
 ** module id = 871
 ** module chunks = 0
 **/